import {CABLE_MANUFACTURERS} from 'const/backend';
import {ONE_HOUR_IN_MS} from 'const/time';
import useApiQuery, {UseApiQuery} from 'hooks/useApiQuery';
import {CableManufacturer} from 'interfaces/Project';
import generatePathWithQueryParams from 'utils/generatePathWithQueryParams';

export default function useGetCableManufacturers(): UseApiQuery<
  [CableManufacturer, ...CableManufacturer[]]
> {
  const path = generatePathWithQueryParams(CABLE_MANUFACTURERS, {});

  return useApiQuery({
    requestOptions: {
      method: 'GET',
      path
    },
    queryOptions: {
      queryKey: [path],
      staleTime: ONE_HOUR_IN_MS,
      suspense: false
    }
  });
}
